import { BaseLayout } from "@components/pages";
import React from "react";

export const CookiesBase = () => {
    return <BaseLayout full />;
};
